import React, { useState } from "react";
import "./NewsPageSection.css";
import { useTranslation } from "react-i18next";
import NewsCard from "../../../../../components/ui/news card/NewsCard";
import { getNews } from "./api";
import { useQuery } from "@tanstack/react-query";
import NewsPopup from "../../../../../components/ui/news popup/NewsPopup";

function NewsPageSection() {
  const [selectedNews, setSelectedNews] = useState(null);

  const { t, i18n } = useTranslation("home");

  const { data, isLoading } = useQuery({
    queryKey: ["news"],
    queryFn: getNews,
  });
  console.log(i18n.language.toLocaleLowerCase());
  if (isLoading) return <p>Loading...</p>;

  return (
    <section className="news-page-section">
      <div className="container news-section-container">
        {data?.map((item) => (
          <NewsCard
            key={item.id}
            image={item.image_url}
            title={item.title?.[i18n.language.toLocaleLowerCase()]}
            description={item.content?.[i18n.language.toLocaleLowerCase()]}
            date={item.created_at_formatted}
            onReadMore={() => setSelectedNews(item)}
          />
        ))}
        <NewsPopup news={selectedNews} onClose={() => setSelectedNews(null)} />
      </div>
    </section>
  );
}

export default NewsPageSection;
